



















import { BlogFilter } from 'client-website-ts-library/filters';
import { Blog, BlogType } from 'client-website-ts-library/types';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { API } from 'client-website-ts-library/services';

@Component
export default class Blogs extends Vue {
  @Prop({ required: true })
  private filter!: BlogFilter;

  private loading = false;

  private posts: Blog[] = [];

  private load(): Promise<boolean> {
    return new Promise((resolve, reject) => {
      if (this.loading) resolve(false);

      this.loading = true;

      API.Blogs.Search(this.filter).then((data) => {
        if (this.filter.Types.indexOf(BlogType.Suburb) !== -1) {
          this.posts = data.sort((a, b) => (a.Title > b.Title ? 1 : -1));
        } else {
          this.posts = data;
        }

        this.loading = false;
      }).catch(reject);
    });
  }

  mounted() {
    this.load();
  }

  @Watch('filter')
  handleFilterChanged() {
    this.load();
  }
}
